export default __webpack_public_path__ + "997acec9ce5db67a6bcfc7ebc032d565.svg";